import { render, staticRenderFns } from "./IncomeTotalBaseTable.vue?vue&type=template&id=19d8a862&"
import script from "./IncomeTotalBaseTable.vue?vue&type=script&lang=js&"
export * from "./IncomeTotalBaseTable.vue?vue&type=script&lang=js&"
import style0 from "./IncomeTotalBaseTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports